export enum Roles {
    Admin = 'Admin',
    ITAdmin = 'IT Admin'
}
